import { sendNotification, useAsyncCache, useRouteParams, useSignalrTopic, useTranslation } from '@msdk/common'
import { useAutoLogOff, useNotifyDefaultClinic } from 'hooks'
import { useNotifyLastLogin } from 'hooks/useNotifyLastLogin'
import { ReactNode } from 'react'

interface Props {
  children?: ReactNode
}

/**
 * This component is a convenient place to initialize application hooks.
 * Here you can initialize hooks that have some logic that should run on startup.
 * Different from the AppInitialized component here all the application providers are available
 * to use, but since they are already initialized it is not possible to block the shell here,
 * so this component should only contain initialization that can run without blocking.
 */
export function ContentIntialized(props: Props) {
  const cache = useAsyncCache()
  const t = useTranslation()
  const routeParam = useRouteParams()

  useAutoLogOff()
  useNotifyDefaultClinic()
  useNotifyLastLogin()

  useSignalrTopic('system.measurement-disease-code-imported', () => {
    if (routeParam.entityName === 'DISEASE_CODE' && routeParam.moduleName?.includes('DISEASE_CODES_VIEW')) {
      setTimeout(() => {
        window.location.reload()
      }, 1500)
    }
  })

  useSignalrTopic('system.measurement-unit-convertions-changed', () => {
    const msg = t(
      'MSG_MEASUREMENT_UNIT_CONVERTIONS_CHANGED',
      'Measurement unit conversions have changed. Page will be reloaded in few seconds.',
    )

    // to avoid be overlapped by other notifications
    setTimeout(() => {
      sendNotification({ message: msg, status: 'warning', waitUserAck: true })
    }, 500)

    setTimeout(() => {
      cache.invalidateFrameworkCache('MeasurementUnit')
      window.location.reload()
    }, 5000)
  })
  return props.children
}
